// extracted by mini-css-extract-plugin
module.exports = {"boxMessage":"Error_boxMessage__2GhRh","imgTop":"Error_imgTop__5D8pb","areaTitle":"Error_areaTitle__3_pJ8","message":"Error_message__1lLhm"};